import { ParsedField } from './typings';

const shouldSetValue = ({ inputField, outputField }: {
  inputField: ParsedField;
  outputField: ParsedField;
} ): boolean => {
  // The output is not in a list/table
  if (outputField.rowIndex === null && outputField.listFieldKey === null) {
    return true;
  }

  // The output is in a list/table
  if (outputField.rowIndex !== null && outputField.listFieldKey !== null) {
    // set the value either if the input was not an array, or if the listFieldKey and rowIndex match
    if (
      (
        outputField.rowIndex === inputField.rowIndex
        && outputField.listFieldKey === inputField.listFieldKey
      )
      || (
        inputField.rowIndex === null
        && inputField.listFieldKey === null
      )
    ) {
      return true;
    }
  }

  return false;
};

export default shouldSetValue;